import { useCallback } from 'react';
import { unwrapResult } from '@reduxjs/toolkit';
import { useAppDispatch } from 'App/store';
import { invoiceRequestById } from '../../ordersSlice';

interface InterfaceOrderInvoices {
  sendInvoiceRequest: () => void;
  handleInvoiceSubmission: () => void;
}

interface useOrderInvoicesProps {
  orderId: string;
  fulfillmentOrderId: string;
  onInvoiceError: () => void;
  onInvoiceRequestSuccess: () => void;
}

function useOrderInvoices({
  orderId,
  fulfillmentOrderId,
  onInvoiceError,
  onInvoiceRequestSuccess,
}: useOrderInvoicesProps): InterfaceOrderInvoices {
  const dispatch = useAppDispatch();

  const sendInvoiceRequest = useCallback(async () => {
    unwrapResult(
      await dispatch(invoiceRequestById({ orderId, fulfillmentOrderId })),
    );
  }, [dispatch, orderId, fulfillmentOrderId]);

  const handleInvoiceSubmission = useCallback(async () => {
    try {
      await sendInvoiceRequest();
      onInvoiceRequestSuccess();
    } catch (error) {
      onInvoiceError();
    }
  }, [sendInvoiceRequest, onInvoiceError, onInvoiceRequestSuccess]);

  return {
    sendInvoiceRequest,
    handleInvoiceSubmission,
  };
}

export default useOrderInvoices;
